const mois = [
  "janvier",
  "février",
  "mars",
  "avril",
  "mai",
  "juin",
  "juillet",
  "août",
  "septembre",
  "octobre",
  "novembre",
  "décembre",
];

//TODO refactor to save date instead of text
export const convertStringToDate = (dateString: string): Date => {
  const [_, day, month, year] = dateString.split(" ");
  return new Date(Date.UTC(Number(year), mois.indexOf(month), Number(day)));
};

export const changeDateFormat = (date: Date): string => {
  return `${date.getUTCFullYear()}-${date.getUTCMonth() + 1}-${date.getUTCDate()}`;
};

export const isLeadWithoutSocials = (lead: { status?: string }) => {
  return (
    lead.status == "refused" ||
    lead.status == "cancelled" ||
    lead.status == "not_transformed"
  );
};
export const removeDoubleDate = <T extends { "@id"?: string }>(
  arr: T[],
): T[] => {
  if (arr.length < 1) return arr;
  const eventArr: T[] = [];
  const mapArr: (string | undefined)[] = [];
  for (const event of arr) {
    if (!mapArr.includes(event["@id"])) {
      mapArr.push(event["@id"]);
      eventArr.push(event);
    } else continue;
  }
  return eventArr;
};

export const getFirstDayOfMonth = (date: Date): number[] => {
  if (!date) return [];
  const tab = [
    "lundi",
    "mardi",
    "mercredi",
    "jeudi",
    "vendredi",
    "samedi",
    "dimanche",
  ];
  let firstDay = new Date(date.getFullYear(), date.getMonth());
  let dayString = firstDay.toLocaleDateString("fr-FR", { weekday: "long" });

  return new Array(tab.indexOf(dayString)).fill(undefined);
};

export function getAllDaysOfMonth(date: Date): number[] {
  if (!date) return [];

  let lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);

  return new Array(lastDayOfMonth.getDate()).fill(undefined);
}

export function generateMonthDaysArray(date: Date): number[] {
  if (!date) return [];

  const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  const daysInMonth = lastDayOfMonth.getDate();

  return Array.from({ length: daysInMonth }, (_, index) => index + 1);
}

// Fonction pour obtenir le nombre de cellules vides nécessaires avant le premier jour du mois
export function getFirstDayOffset(date: Date): number[] {
  const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
  let dayOfWeek = firstDayOfMonth.getDay(); // 0 (Dimanche) à 6 (Samedi)

  // Ajuster pour que Lundi soit le premier jour (0) et Dimanche le dernier (6)
  dayOfWeek = dayOfWeek === 0 ? 6 : dayOfWeek - 1;

  return Array(dayOfWeek).fill(null);
}
